export const CATEGORY_OPTIONS = [
  { code: "T", translationKey: "cat_T" },
  { code: "D", translationKey: "cat_D" },
  { code: "QS", translationKey: "cat_QS" },
  { code: "QP", translationKey: "cat_QP" },
  { code: "C", translationKey: "cat_C" },
  { code: "V", translationKey: "cat_V" },
  { code: "Dx", translationKey: "cat_Dx" },
  { code: "G", translationKey: "cat_G" },
  { code: "H", translationKey: "cat_H" },
  { code: "J", translationKey: "cat_J" },
  { code: "W", translationKey: "cat_W" },
  { code: "X", translationKey: "cat_X" },
  { code: "S", translationKey: "cat_S" },
  { code: "A", translationKey: "cat_A" },
  { code: "R", translationKey: "cat_R" },
  { code: "E", translationKey: "cat_E" },
];

export const EXCLUSION_SUBCODE_OPTIONS = [
  { code: "E-g", translationKey: "exc_g" },
  { code: "E-x", translationKey: "exc_x" },
  { code: "E-z", translationKey: "exc_z" },
  { code: "E-p", translationKey: "exc_p" },
  { code: "E-q", translationKey: "exc_q" },
  { code: "E-i", translationKey: "exc_i" },
  { code: "E-b", translationKey: "exc_b" },
  { code: "E-s", translationKey: "exc_s" },
  { code: "E-c", translationKey: "exc_c" },
  { code: "E-m", translationKey: "exc_m" },
  { code: "E-d", translationKey: "exc_d" },
  { code: "E-r", translationKey: "exc_r" },
];

export const CATEGORY_CHANGE_REASON_OPTIONS = [
  { value: "diagnosis", translationKey: "feedbackReasonDiagnosis" },
  {
    value: "treatment_context",
    translationKey: "feedbackReasonTreatmentContext",
  },
  { value: "item_text_or_ocr", translationKey: "feedbackReasonItemTextOrOcr" },
  { value: "exclusion_rule", translationKey: "feedbackReasonExclusionRule" },
  { value: "invoice_context", translationKey: "feedbackReasonInvoiceContext" },
  {
    value: "duplicate_or_wrong_line",
    translationKey: "feedbackReasonDuplicateOrWrongLine",
  },
  { value: "expert_judgment", translationKey: "feedbackReasonExpertJudgment" },
  { value: "other", translationKey: "feedbackReasonOther" },
];

const COLOR_GROUPS = {
  treatment: ["T", "H", "J", "W"],
  preventive: ["QS", "QP", "V"],
  exclusion: ["E"],
  administrative: ["A", "R", "X", "S", "D"],
  other: ["C", "Dx", "G"],
};

export function getCategoryThemeClass(code) {
  if (!code) return "";
  const normalized = code.trim();
  for (const [group, codes] of Object.entries(COLOR_GROUPS)) {
    if (codes.includes(normalized)) return `lineitem-ai-theme--${group}`;
  }
  return "";
}

export const getCategoryColorClass = getCategoryThemeClass;
